import "../../../../../../src/style/block.scss";
import "./style.scss";
import "../../../../../../src/style/buttons.scss";
import React, { useState } from "react";
import { Assort } from "../../../../models/Assort";
import { MdCheckBox, MdOutlineCheckBoxOutlineBlank } from "react-icons/md";
import EAButton from "../../../shared/Buttons/EAButton";

interface IProps {
  title: string;
  data: Assort[];
  onSelect: (value: Assort) => void;
}
const SortModal: React.FC<IProps> = ({ title, data, onSelect }) => {
  const [open, setIndex] = useState(60);

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <>
      <p>{title}</p>
      <div className="SortModal">
        {data.map((item, index) => (
          <EAButton
            key={index}
            onClick={() => {
              setIndex(index);
              onSelect(item);
            }}
            title={item.name}
            startIcon={index === open ? <MdCheckBox /> : <MdOutlineCheckBoxOutlineBlank />}
            variant="text"
            noMargins
          />
        ))}
      </div>
    </>
  );
};

export default SortModal;
